import React, { useState } from "react";

import { isMobile, isTablet, isDesktop } from "react-device-detect";
import {
  Grid,
  Typography,
  TextField,
  Link,
  Button,
  CircularProgress
} from "@mui/material";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import useStyles from "./Login.styles";
import { loginStart } from "../../../redux-saga/redux/auth/authentication";
import ForgotPasswordModal from "./ForgotPasswordModal";

const Login = ({ handleCloseLogin, style, isHome }) => {
  const defaultClasses = useStyles();
  const classes = style ? style : defaultClasses;
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [show, setShow] = useState(false);
  const [userNameOrEmail, setUserNameOrEmail] = useState("");
  const [password, setPassword] = useState("");
  const [forgotPassword, setForgotPassword] = useState(false);

  const { loading, metamaskLoading } = useSelector(
    (state) => state.authentication
  );
  const deviceType = isTablet
    ? "Tablet"
    : isMobile
      ? "Mobile"
      : isDesktop
        ? "Desktop"
        : null;

  const handleLoginAuth = (e) => {
    e.preventDefault();
    const validation = [];
    if (userNameOrEmail.length === 0) {
      validation.push(t("COMMON.EMAIL_EMPTY"));
    } else if (!userNameOrEmail || !userNameOrEmail.trim()) {
      validation.push(t("HEADER.USERNAME_EMAIL_ERROR_MSG"));
    }
    if (password.trim().length === 0) {
      validation.push(t("COMMON.PASSWORD_EMPTY"));
    }
    if (validation.length !== 0) {
      let msg = "";
      validation.forEach((message) => {
        msg = msg ? `${msg}, \n${message}` : `${message}`;
      });
      toast.error(msg.replace(".", ""), {
        id: msg
      });
      return;
    }

    dispatch(
      loginStart({
        userNameOrEmail: userNameOrEmail?.trim(),
        password: window.btoa(password?.trim()),
        deviceType: deviceType
      })
    );
  };

  const handlePassword = (e) => {
    setPassword(e.target.value);
  };

  const handleEmail = (e) => {
    setUserNameOrEmail(e.target.value);
  };

  const handleShow = (e) => {
    e.preventDefault();
    setShow((prevState) => !prevState);
  };

  const handleGoToForgotPassword = () => {
    setForgotPassword((prevState) => !prevState);
  };

  return (
    <Grid>
      {forgotPassword ? (
        <ForgotPasswordModal handleCloseLogin={handleCloseLogin} />
      ) : (
        <>
          <Grid className={classes.loginContent}>
            <Typography variant="h5">{t("HEADER.LOG_IN")}</Typography>
          </Grid>
          <Grid className={classes.loginFormWrap}>
            <form>
              <Grid className={classes.formGroup}>
                <TextField
                  type="userNameOrEmail"
                  id="userNameOrEmail"
                  label={t("HEADER.USERNAME_EMAIL")}
                  variant="outlined"
                  onChange={handleEmail}
                />
              </Grid>
              <Grid className={classes.formGroup}>
                <TextField
                  type={show ? "text" : "password"}
                  id="pwd"
                  label={t("COMMON.PASSWORD")}
                  variant="outlined"
                  onChange={handlePassword}
                />
                <Link
                  href="#"
                  className={classes.showLink}
                  onClick={handleShow}
                >
                  {!show ? t("COMMON.SHOW") : t("COMMON.HIDE")}
                </Link>
              </Grid>
              <Grid className={classes.authBtnWrap}>
                <Button
                  type="submit"
                  className={classes.btnPrimary}
                  onClick={handleLoginAuth}
                  disabled={loading || metamaskLoading}
                >
                  {loading ? (
                    <CircularProgress size="1.5rem" />
                  ) : (
                    t("HEADER.LOG_IN")
                  )}
                </Button>
                {/* <Typography>{t("HEADER.OR")}</Typography>
                <Button
                  className={classes.btnPrimary}
                  onClick={handleLoginMetamask}
                  disabled={metamaskLoading || loading}
                >
                  {metamaskLoading ? (
                    <CircularProgress size="1.5rem" />
                  ) : (
                    t("HEADER.CONTINUE_METAMASK")
                  )}
                </Button> */}
              </Grid>
            </form>
            <Grid className={classes.forgotLink}>
              <Button onClick={handleGoToForgotPassword}>
                {t("HEADER.FORGOT_PASSWORD_MARK")}
              </Button>
            </Grid>
            {/* <Grid className={classes.signUpLink}>
              {t("HEADER.SIGN_UP_MSG")}
              <Button onClick={handleGoToSignUp}>
                {t("HEADER.SIGN_UP_MARK")}
              </Button>
            </Grid> */}
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default Login;
